import { VariantCopyController } from './copy/variant_copy.controller';
import { VariantCreateController } from './create/variant_create.controller';
import { VariantDetailController } from './detail/variant_detail.controller';
import { VariantEditController } from './edit/variant_edit.controller';
import { VariantListController } from './list/variant_list.controller';
import { VariantPageController } from './page/variant_page.controller';
import { VariantProductFieldsController } from './product_fields/variant_product_fields.controller';
import { IControllerConstructor } from 'angular';

export const initialise = () => {
  angular.module('app.variant', [
    'pascalprecht.translate',
    'actora.services',
    'app.layout',
    'app.components'
  ])
    .controller('VariantCopyController', <IControllerConstructor>VariantCopyController)
    .controller('VariantCreateController', <IControllerConstructor>VariantCreateController)
    .controller('VariantDetailController', <IControllerConstructor>VariantDetailController)
    .controller('VariantEditController', <IControllerConstructor>VariantEditController)
    .controller('VariantListController', <IControllerConstructor>VariantListController)
    .controller('VariantPageController', <IControllerConstructor>VariantPageController)
    .controller('VariantProductFieldsController', <IControllerConstructor>VariantProductFieldsController);
};